import zones from '../riskZones.json';
import roads from '../road.json';
import styles from '../styles/styles';

// Zones
export const riskAssessmentZonesBig = {
	key: "risk-assessment-zones-big",
	type: "vector",
	options: {
		features: zones.features,
		style: styles.byKey.riskAssessmentZonesP75Big.data.definition,
		fidColumnName: "join_id",
		hoverable: true,
		hovered: {
			style: "default"
		},
		selectable: true,
		selected: {
			riskAssessmentZones: {}
		}
	}
};

export const riskAssessmentZonesSmall = {
	key: "risk-assessment-zones-small",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.riskAssessmentZonesP75Small.data.definition,
		fidColumnName: "join_id",
		selected: {
			riskAssessmentZones: {}
		}
	}
};

// Roads
export const riskAssessmentRoadsBig = {
	key: "risk-assessment-roads-big",
	type: "vector",
	options: {
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsP75Big.data.definition,
		fidColumnName: "zone_id",
		hoverable: true,
		hovered: {
			style: {
				outlineColor: "#00ffff"
			}
		},
		selectable: true,
		selected: {
			riskAssessmentRoads: {}
		}
	}
};

export const riskAssessmentRoadsSmall = {
	key: "risk-assessment-roads-small",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsP75Small.data.definition,
		fidColumnName: "zone_id",
		selected: {
			riskAssessmentRoads: {}
		}
	}
};

// Points
export const interferometryPointsBig = {
	key: "interferometry-points-big",
	type: "vector",
	options: {
		renderAs: [
			{
				options: {
					renderingTechnique: 'canvas',
					pointAsMarker: false,
					style:
					styles.byKey.interferometryPointsDisplacementBigAsPoints.data.definition,
				},
				boxRangeRange: [1000, null],
			},
			{
				boxRangeRange: [null, 1000],
			},
		],
		pointAsMarker: true,
		features: [],
		hoverable: true,
		hovered: {
			style: "default"
		},
		selectable: true,
		selected: {
			interferometry: {}
		},
		style: styles.byKey.interferometryPointsDisplacementBig.data.definition,
		fidColumnName: "id"
	}
};

export const interferometryPointsSmall = {
	key: "interferometry-points-small",
	type: "vector",
	options: {
		pointAsMarker: true,
		renderingTechnique: 'canvas',
		features: [],
		style: styles.byKey.interferometryPointsDisplacementSmall.data.definition,
		fidColumnName: "id"
	}
};

export const interferometryZonesBig = {
	key: "interferometry-zones-big",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.interferometryZonesBig.data.definition,
		fidColumnName: "join_id",
		selected: {
			riskAssessmentZones: {}
		}
	}
};

export const interferometryZonesSmall = {
	key: "interferometry-zones-small",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.interferometryZonesSmall.data.definition,
		fidColumnName: "join_id",
		selected: {
			riskAssessmentZones: {}
		}
	}
};

export const interferometryRoadsBig = {
	key: "interferometry-roads-big",
	name: "Roads",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsP75Big.data.definition,
		fidColumnName: "zone_id",
		selected: {
			riskAssessmentRoads: {}
		}
	}
};

export const interferometryRoadsSmall = {
	key: "interferometry-roads-small",
	name: "Roads",
	type: "vector",
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsP75Small.data.definition,
		fidColumnName: "zone_id",
		selected: {
			riskAssessmentRoads: {}
		}
	}
};

export default {
	riskAssessmentZonesBig,
	riskAssessmentZonesSmall,
	riskAssessmentRoadsBig,
	riskAssessmentRoadsSmall,
	interferometryZonesBig,
	interferometryZonesSmall,
	interferometryRoadsBig,
	interferometryRoadsSmall,
	interferometryPointsBig,
	interferometryPointsSmall
}